/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManagerEmployeeTimesheetView, PostTimesheet, Timesheet, TimesheetApprovalSubmission, UserTimesheet } from 'src/app/store/application';

@Injectable()
export class TimesheetService {
	timesheetsUrl = 'api/timesheets';
	approvalsUrl = 'api/approvals';

	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	constructor(private httpClient: HttpClient) {}

	getTimesheets(): Observable<Timesheet[]> {
		return this.httpClient.get<Timesheet[]>(`${this.timesheetsUrl}`, this.httpOptions);
	}

	getAllUserTimesheets(userIds: number[]): Observable<UserTimesheet[]> {
		return this.httpClient.get<UserTimesheet[]>(`${this.timesheetsUrl}/getAllUserTimesheets?userIds=${userIds.toString()}`, this.httpOptions);
	}

	getApprovedTimesheets(userIds: number[], includeAllMonthTimesheets: boolean = false, isManagerView: boolean = false): Observable<UserTimesheet[]> {
		return this.httpClient.get<UserTimesheet[]>(
			`${this.timesheetsUrl}/getapprovedtimesheets?allMonthTimesheets=${includeAllMonthTimesheets ? true : false}&managerView=${
				isManagerView ? true : false
			}&userIds=${userIds.toString()}`,
			this.httpOptions
		);
	}

	postTimesheet(date: string, timesheet: PostTimesheet): Observable<any> {
		return this.httpClient.post(`${this.timesheetsUrl}/${date}`, timesheet, this.httpOptions);
	}

	approveEmployeeTimesheets(submissions: TimesheetApprovalSubmission[]): Observable<any> {
		return this.httpClient.post(`${this.timesheetsUrl}/approvals`, submissions, this.httpOptions);
	}

	getEmployeeTimesheets(): Observable<ManagerEmployeeTimesheetView[]> {
		return this.httpClient.get<ManagerEmployeeTimesheetView[]>(`${this.approvalsUrl}/timesheetApprovals`, this.httpOptions);
	}

	getTimesheetHistory(startDate: string, employeeNumber?: string): Observable<Timesheet[]> {
		let url = `history/${startDate}`;

		if (employeeNumber) {
			url = url + `/${employeeNumber}`;
		}

		return this.httpClient.get<Timesheet[]>(`${this.timesheetsUrl}/${url}`, this.httpOptions);
	}

	closeTimeEntries(): Observable<any> {
		return this.httpClient.post(`${this.timesheetsUrl}/closePostings`, null, this.httpOptions);
	}
}
